import type { WindowProps } from '@client/window/window.types';
import type { ManageTradingTemplatesProps } from './manage-trading-templates';

type OpenManageTradingTemplatesWindowArgs = {
  openWindow: (windowProps: WindowProps) => void;
} & ManageTradingTemplatesProps;

export const openManageTradingTemplatesWindow = ({
  openWindow,
  ...componentProps
}: OpenManageTradingTemplatesWindowArgs) => {
  openWindow({
    type: 'ManageTradingTemplates',
    sizePreset: 'grid',
    componentProps
  });
};
